var shvenergy = shvenergy || {};

shvenergy.search.gui = (function ($) {
    "use strict";
    var searchResults = $(".search-result");

    const mapSideBarToggleButton = $("button[data-toggle-sidebar]");
    var mapSidebar = $("#map-sidebar");
    var mapSidebarContent = $(".search__filter.search__pane");

    var listSidebar = $(".search__list");

    var detailsWrapper = $(".map-dealerdetails");

    var mapCustomSearchButton = $("#map-custom-search-button");

    var intro = $(".map-sidebar__intro");
    const useCurrentLocationButton = $("#useCurrentLocationButton");
    var searchFilters = $(".search__filter.search__pane");
    var bactostart = $(".search__back-tostart");

    const mobileViewSelectors = window.matchMedia('(max-width: 640px)');

    var mapStateStore = {
        mapView: (() => {
            const view = new URL(window.location).searchParams.get('view');
            if (view === 'list') {
                return false;
            }
            return true;
        })(),
        mapViewListener: function (val) { },
        set mapVisible(val) {
            if (this.mapView !== val) {
                this.mapView = val;
                this.mapViewListener(val);
            }
        },
        get mapVisible() {
            return this.mapView;
        },
        registerListener: function (listener) {
            this.mapViewListener = listener;
            this.mapViewListener(this.mapView);
        },

        placeDetails: null,
        placeDetailsListener: function (val) { },
        set placeDetailsContent(val) {
            this.placeDetails = val;
            this.placeDetailsListener(val);
        },
        get placeDetailsContent() {
            return this.placeDetails;
        },
        registerPlaceDetailsListener: function (listener) {
            this.placeDetailsListener = listener;
        }
    };

    var mapClearSearchButtonStore = {
        isVisible: false,
        clearSearchButtonListener: function (val) { },
        set clearSearchButtonVisible(val) {
            this.isVisible = val;
            this.clearSearchButtonListener(val);
        },
        get clearSearchButtonVisible() {
            return this.isVisible;
        },
        registerListener: function (listener) {
            this.clearSearchButtonListener = listener;
        }
    };

    setTimeout(() => {
        mapSidebarContent.css({
            "opacity": ""
        });
    }, 100);

    setTimeout(() => {
        detailsWrapper.css({
            "max-width": "",
            "opacity": "",
            "z-index": "",
            "-webkit-transform": "",
            "transform": ""
        });

    }, 150);

    setTimeout(() => {
        mapSidebar.css("opacity", "1");
    }, 200);


    function reorderPanels(mapVisible = mapStateStore.mapVisible) {
        const searchControls = $('.search__controls');
        const isMobile = mobileViewSelectors.matches;
        if (!isMobile) {
            $('.map-sidebar__content').prepend(searchControls);
            return;
        };


        if (mapVisible) {
            $('.search__controls--mobile-container').append(searchControls);
        } else {
            $('.map-sidebar__content').prepend(searchControls);
        }
    }

    mapStateStore.registerListener(function (mapVisible) {
        var searchUrl = new URL(window.location);
        const display = mapVisible ? 'map' : 'list';
        const toggleMobileListViewText = $('[data-mobile-toggle-sidebar] > span[data-mobile-toggle-list-view]');
        const toggleMobileMapViewText = $('[data-mobile-toggle-sidebar] > span[data-mobile-toggle-map-view]');

        if (mapVisible) {
            mapSidebar.addClass("is-invisible");
            listSidebar.addClass("is-invisible");

            toggleMobileListViewText.show();
            toggleMobileMapViewText.hide();
        } else {
            mapSidebar.removeClass("is-invisible");
            listSidebar.removeClass("is-invisible");

            toggleMobileListViewText.hide();
            toggleMobileMapViewText.show();
        }


        shvenergy.tracking.trackEvent('Dealerfinder', 'Viewtype', `${display} view`);

        shvenergy.tracking.trackRawEventData({
            'event': 'clickDFView',
            'viewType': display
        });
        historyPushState();
        toggleMobileButtons();

        reorderPanels(mapVisible);
    });

    mapClearSearchButtonStore.registerListener(function (val) {
        var mapClearSearchButton = $("#map-clearsearchbutton");
        if (mapClearSearchButtonStore.clearSearchButtonVisible) {
            mapClearSearchButton.show();
        } else {
            mapClearSearchButton.hide();
            $("#map-searchinput").val("");
            searchResults.empty();
        }
    });

    function toggleMobileListInfoText() {
        const toggles = $('[name=toggle]');
        const selector = toggles.length === 1
            ? '[name=toggle]'
            : '[name=toggle]:checked';

        const title = $(selector).data('mobilelistviewinfotext');
        $('span#retailer-info-headline').text(title);
    }

    function toggleMobileButtons() {
        const isMapView = mapStateStore.mapView;
        const searchResultsCount = $('#dealerTarget').children().length;

        $('input#map-searchinput').show();
        $('#useCurrentLocationButton').removeClass('hide-for-small-only');

        if (!mobileViewSelectors.matches) return;

        $('.search__toggle-mobile').show();

        if (isMapView) {
            $('#useCurrentLocationButton').removeClass('hide-for-small-only');
        } else {
            $('#useCurrentLocationButton').addClass('hide-for-small-only');
        }

        const infoContainer = $('[data-mobile-info-container]');
        const mobileToggleContainer = $('[data-mobile-toggle-sidebar-container]');

        if (isMapView) {
            if (searchResultsCount > 0) {
                infoContainer.hide();
                mobileToggleContainer.show();
            } else {
                infoContainer.show();
                mobileToggleContainer.hide();
            }
        } else {
            infoContainer.hide();
            mobileToggleContainer.show();

            if (searchResultsCount > 0) {
                $('input#map-searchinput').show();
            } else {
                $('input#map-searchinput').hide();
            }
        }
    }

    const searchResultsObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                toggleMobileButtons();
            }
        }
    })

    // TODO: refactor these, should be in the same handler
    mapSideBarToggleButton.on("click", function (e) {
        e.stopPropagation();
        mapStateStore.mapVisible = !mapStateStore.mapVisible;
    });

    $('*[data-mobile-toggle-sidebar]').on('click', function (e) {
        e.stopPropagation();
        listSidebar.removeClass('hide-for-small-only');

        mapStateStore.mapVisible = !mapStateStore.mapVisible;
        toggleMobileButtons();
    });

    $('*[data-mobile-show-results]').on('click', function (e) {
        e.stopPropagation();
        listSidebar.removeClass('hide-for-small-only');

        mapStateStore.mapVisible = true;

        // TODO rework duplicate code: see line 347
        $(this).parents('.search__pane').toggleClass('search__pane--active');
        $(this).parents('.search__pane').toggleClass('is-invisible');

        // shvenergy.maps.fitBounds(shvenergy.maps.getStoredBounds());
        // shvenergy.maps.setZoom(shvenergy.maps.getStoredZoom());
        shvenergy.maps.setIsZoomedAndCenteredOnMarker(false);
    })

    $('*[data-toggle-mobile-info]').on('click', function (e) {
        $('.map-sidebar__mobile-info').toggleClass('is-invisible');
    });

    mapCustomSearchButton.on("click", function () {
        mapSidebar.removeClass("is-invisible");
        listSidebar.addClass("is-invisible");
        $('body').addClass("map-search");
    });

    function historyPushState(term = $('#map-searchinput').val()) {
        var searchUrl = new URL(window.location);
        var type = shvenergy.search.dealer.getType();
        const display = mapStateStore.mapVisible
            ? searchUrl.searchParams.get('view') === 'details' ? 'details' : 'map'
            : 'list';

        if (!!term) {
            searchUrl.searchParams.set('search', term);
        }
        searchUrl.searchParams.set('view', display);
        searchUrl.searchParams.set('dealerType', type);

        const TAG_FILTER_NAME = `${type}-Tag`;
        let filterQuerystring = "";
        const currentFilters = document.querySelectorAll(`[data-filterwasdefaultchecked='true'][data-type='${TAG_FILTER_NAME}']`);
        currentFilters.forEach(function (filter) {
            filterQuerystring += "&filter=" + filter.dataset.queryparametername;
        });
        const builtQuery = '?' + searchUrl.searchParams.toString();

        window.history.pushState({}, '', builtQuery);
    }

    function historyReplaceState(term = $('#map-searchinput').val()) {
        var searchUrl = new URL(window.location);
        var type = shvenergy.search.dealer.getType();
        const display = mapStateStore.mapVisible
            ? searchUrl.searchParams.get('view') === 'details' ? 'details' : 'map'
            : 'list';

        if (!!term) {
            searchUrl.searchParams.set('search', term);
        }
        const currentSearcUrl = '?' + searchUrl.searchParams.toString();

        searchUrl.searchParams.set('view', display);
        searchUrl.searchParams.set('dealerType', type);

        const builtQuery = '?' + searchUrl.searchParams.toString();

        if (window.history.replaceState && !(builtQuery === currentSearcUrl)) {
            window.history.pushState({}, '', builtQuery);
        }
    }

    $(".search__filter.search__pane input[type=checkbox]").on("click", function (e) {

        e.stopPropagation();
        var bounds = shvenergy.maps.getBounds();
        var zoomLevel = shvenergy.maps.getZoom();
        shvenergy.search.dealer.searchByLocation(bounds, zoomLevel);

        //For autogas dealer brand filters we need to uncheck all sub checkboxes
        if (e.target.checked === false && e.target.matches('[data-type="Autogas-DealerBrandFilter"]')) {
            const id = e.target.id;
            const pane = $("[data-paneid='" + id + "']");
            const checkboxes = pane.find("input[type=checkbox]");

            checkboxes.each(function (index, element) {
                $(this).prop("checked", false);
            });
        }
        shvenergy.search.filters.updateFilterCount();

        let filterTitle;
        if (e.target.parentElement.querySelector('label span.filter__title')) {
            filterTitle = e.target.parentElement.querySelector('label span.filter__title').innerText
        }
        else if (e.target.parentElement.querySelector('label span.toggle-switch__title')) {
            filterTitle = e.target.parentElement.querySelector('label span.toggle-switch__title').innerText
        }
        else {
            filterTitle = e.target.parentElement.querySelector('label span').innerText;
        }

        shvenergy.tracking.trackRawEventData({
            'event': 'clickDFFilter',
            'filterName': filterTitle,
            'action': e.target.checked ? 'on' : 'off'
        });
    });

    useCurrentLocationButton.on("click", function (e) {
        e.stopPropagation();
        shvenergy.maps.useGeoLocation(true);
        var type = shvenergy.search.dealer.getType();
        var term = $("#map-searchinput").val();
        window.history.pushState(null, null, '?search=' + term + '&dealerType=' + type);
        if (shvenergy.utils.isMobile()) {
            shvenergy.search.gui.mapStateStore.mapVisible = true;
        }

        shvenergy.tracking.trackRawEventData({
            'event': 'clickDFSearch',
            'searchType': 'Geolocalization',
            'query': term
        });

    });

    $(".search__filter__type-button").on("click", function () {
        var self = $(this);
        var id = self.attr("id");
        $("[data-paneid='" + id + "']").addClass("isActive");
    });


    $("[data-closedealerfilter]").on("click", function (e) {
        e.stopPropagation();
        $(this).parents(".search__dealerfilter").removeClass("isActive");
    });

    bactostart.on("click", function (e) {
        e.stopPropagation();

        setTimeout(function () {
            shvenergy.maps.intro.show();
            $("#dealerTarget").empty();
            $("#map-searchinput").val("");
            shvenergy.search.gui.setBactoStartState(true);
            shvenergy.maps.setZoom(shvenergy.maps.initialZoom);
            shvenergy.maps.setCenter(shvenergy.maps.initialPosition);
            //shvenergy.maps.hideCurrentLocation();
            // shvenergy.search.filters.resetFilters();
            window.history.pushState({}, document.title, window.location.pathname);
            shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = false;
            shvenergy.maps.hideMarker();
        }, 500);

    });

    // delegations for lazy loaded elements
    $(document)
        .on("mouseenter", ".search__item", function () {
            var dealerId = $(this).attr("dealerid");
            shvenergy.maps.setMarker(dealerId, true);
        })
        .on("mouseleave", ".search__item", function () {
            var dealerId = $(this).attr("dealerid");
            shvenergy.maps.setMarker(dealerId, false);
        })
        .on("click", ".search__item", function () {
            console.log("Reset placedetails in the store");
            shvenergy.search.gui.mapStateStore.placeDetails = null;
            shvenergy.maps.storeZoomAndBounds();
            shvenergy.search.dealer.getDetails($(this).attr("dealerid"));
            var marker = shvenergy.maps.getMarkerById($(this).attr("dealerid"));
            shvenergy.maps.zoomAndCenterOnMarker(marker);
        })
        .on("click", ".search__back", function (e) {
            e.stopPropagation();
            $(this).parents('.search__pane').toggleClass('search__pane--active');
            $(this).parents('.search__pane').toggleClass('is-invisible');

            // shvenergy.maps.fitBounds(shvenergy.maps.getStoredBounds());
            // shvenergy.maps.setZoom(shvenergy.maps.getStoredZoom());
            shvenergy.maps.setIsZoomedAndCenteredOnMarker(false);
        })
        .on("click", ".get-directions.search__details__links", function (e) {
            e.stopPropagation();
            shvenergy.tracking.trackRawEventData({
                'event': 'clickDFRetailerAction',
                'action': 'Get Direction'
            });
        })
        .on("click", ".search__details__link__telephone", function (e) {
            e.stopPropagation();
            shvenergy.tracking.trackRawEventData({
                'event': 'clickDFRetailerAction',
                'action': 'Phone Number'
            });
        })
        .on("click", "#openingHoursButton", function (e) {
            e.stopPropagation();

            const placeId = $(this).data("placeId");
            if (placeId) {
                setOpeningHours(placeId);
            } else {
                getPlaceId(setOpeningHours);
            }
        })
        .on("click", 'input[name=toggle]', function (e) {
            shvenergy.search.dealer.setType(this.value);

            var bounds = shvenergy.maps.getBounds();
            var zoomLevel = shvenergy.maps.getZoom();
            shvenergy.search.dealer.searchByLocation(bounds, zoomLevel);
            shvenergy.search.filters.updateFiltersByType();
            $('label[for="map-searchinput"]').text($(this).data("searchareahelptext"));
            historyReplaceState($("#map-searchinput").val());
            shvenergy.search.filters.updateFilterCount();
            clearSuggestions();
            const filterButton = $('.search__back--filter');
            if ($(this).data('hideavailablefiltersbutton') == true) {
                filterButton.hide();
            } else {
                filterButton.show();

                const checkboxes = $(`input[type="checkbox"][data-dealertypename="${this.value}"]`)
                const disabled = checkboxes.length === 0;
                filterButton.attr('disabled', disabled);
            }


            toggleMobileListInfoText();


            shvenergy.tracking.trackRawEventData({
                'event': 'clickDFType',
                'action': this.value
            });
        })
        .on('click', '#map-searchbutton', function (e) {
            e.stopPropagation();

            mapSidebar.addClass("is-invisible");

            shvenergy.maps.setKeepSearchingIfNoResults(true);
            const val = $("#map-searchinput").val();

            if (val.length <= 0 && shvenergy.utils.isMobile()) {
                shvenergy.search.gui.mapStateStore.mapVisible = true;
                return;
            }

            if (val.length > 0) {
                shvenergy.search.gui.mapStateStore.mapVisible = true;
                //shvenergy.bounce.clearNamed(constBounceKey);
                //shvenergy.search.address.autocomplete(mapSearchInput.val(), currentResults, shvenergy.search.setFirstPrediction);
                historyReplaceState(val);
                //return;

                shvenergy.tracking.trackRawEventData({
                    'event': 'clickDFSearch',
                    'searchType': 'Manual search',
                    'query': val
                });
            }
        })
        .on('click', '#map-clearsearchbutton', function (e) {
            e.stopPropagation();

            shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = false;

            const category = $(this).data("category");
            const action = $(this).data("action");
            const label = $(this).data("label");

            shvenergy.tracking.trackEvent(category, action, label);
        })
        .on('click', '.search__filters, .js-search-filter', function (e) {
            searchFilters.toggleClass("search__pane--active");
            searchFilters.toggleClass("is-invisible");

            shvenergy.search.filters.updateFiltersByType();
        });

    function getPlaceId(callback) {
        var dealerName = $("#searchDetails").data("dealername");
        var lat = parseFloat($("#searchDetails").data("locationlat"));
        var lng = parseFloat($("#searchDetails").data("locationlng"));
        shvenergy.maps.getPlaceId({ lat: lat, lng: lng }, dealerName, callback);
    }

    /* while using geo location, Sometimes Search Input is populated with text.
    So to enable the clear search button check this code */
    $(function () {
        shvenergy.search.gui.mapClearSearchButtonStore.clearSearchButtonVisible = $("#map-searchinput").val().length > 0;
    });

    function setCurrentSearch(val) {
        $("#map-searchinput").val(val);
    }

    function clearSuggestions() {
        searchResults.empty();
    }

    function useFallBackText() {
        const fallBackText = $("#openingHoursButton").data("no-opening-hours-fallback-text");
        const listItem = $("<li/>");
        const weekdayNameSpan = $("<span>", {
            "text": fallBackText,
            "class": "weekday-name-label"
        });
        weekdayNameSpan.appendTo(listItem);
        listItem.appendTo($(".search__details__links__date-list"));
        toggleOpeningHoursList();
    }

    function toggleOpeningHoursList() {
        if ($("#openingHoursList").css('display') !== 'none') {
            $("#openingHoursList").slideUp();
        } else {
            $("#openingHoursList").slideDown();
        }
    }

    function buildOpeningHoursHtml(data) {
        console.log("DATA:", data);
        if (data && data.weekday_text && data.weekday_text.length) {

            for (var i = 0; i < data.weekday_text.length; i++) {

                var arr = []; //new storage
                var listItem = $("<li/>");

                var str = data.weekday_text[i].split(' '); //split by spaces
                arr.push(str.shift()); //add the number
                arr.push(str.join(' ')); //and the rest of the string

                var weekdayNameSpan = $("<span>",
                    {
                        "text": arr[0],
                        "class": "weekday-name-label"
                    });

                weekdayNameSpan.appendTo(listItem);

                try {
                    //console.log(arr[1]);
                    var openingHoursSpan = $("<span>",
                        {
                            "text": arr[1],
                            "class": "opening-hours-label"
                        });
                    openingHoursSpan.appendTo(listItem);
                } catch (error) {
                    console.log(error);
                }

                listItem.appendTo($(".search__details__links__date-list"));

            }

            setTimeout(function () {
                toggleOpeningHoursList();
            }, 500);

        } else {
            console.log("useFallBackText() function running from within buildOpeningHoursHtml(data)");
            useFallBackText();
        }
    }



    function setOpeningHours(placeId) {

        let fallBackText = $(this).data("no-opening-hours-fallback-text");

        if (fallBackText == undefined) {
            fallBackText = $('#openingHoursButton').data("no-opening-hours-fallback-text");
        }

        console.log("PLACEID clicked:", placeId);


        if (!$(".search__details__links__date-list").is(":empty")) {
            //If we have already populated the list with data, don't do it again, but simply toggle the list
            toggleOpeningHoursList();
            return;
        }


        if (placeId && placeId.length) {
            console.log("PlaceId exist, now load them from google");

            if (shvenergy.search.gui.mapStateStore.placeDetails === null) {
                console.log("We do not have any placeDetails data available, so fetch it from Google");
                const mapservice = shvenergy.maps.loadGoogleMapsService();

                mapservice.getDetails({
                    placeId: placeId,
                    fields: ['opening_hours']
                }, function (place, status) {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        console.log("PLACE: ", place);
                        if (place.opening_hours) {
                            const data = place.opening_hours;
                            console.log("DATA2__:", data);
                            buildOpeningHoursHtml(data);
                        }
                        else {
                            useFallBackText();
                        }
                    }
                });
            } else {
                console.log("We have placeDetails data available, so use it instead of a new request");
                buildOpeningHoursHtml(shvenergy.search.gui.mapStateStore.placeDetails.opening_hours);
            }
        } else {
            var listItem = $("<li/>");
            var weekdayNameSpan = $("<span>", {
                "text": fallBackText,
                "class": "weekday-name-label"
            });
            weekdayNameSpan.appendTo(listItem);
            listItem.appendTo($(".search__details__links__date-list"));

            toggleOpeningHoursList();
        }

        $(this).removeData("placeId");
    }

    function setGooglePhoneNumber(data) {
        //console.log("data: ", data);
        const linkToReplaceNumberIn = $("#GooglePhoneNumber");

        if (linkToReplaceNumberIn && linkToReplaceNumberIn.length && data) {
            const span = linkToReplaceNumberIn.find("span");
            linkToReplaceNumberIn.attr("href", `tel:${data.replace(" ", "")}`);
            span.text(data);
        }
        linkToReplaceNumberIn.slideDown();

    }

    function hideDetails() {
        $(".map-dealerdetails").removeClass("isActive");
        shvenergy.maps.fitBounds(shvenergy.maps.getStoredBounds());
        shvenergy.maps.setZoom(shvenergy.maps.getStoredZoom());
        shvenergy.maps.setIsZoomedAndCenteredOnMarker(false);
    }

    function setBactoStartState(state) {
        bactostart.prop("disabled", state);
    }


    $(function () {

        mobileViewSelectors.addEventListener('change', ev => {
            reorderPanels();
        });

        searchResultsObserver.observe(
            $('#dealerTarget')[0],
            { childList: true }
        );

        shvenergy.search.filters.updateFilterCount();
        toggleMobileListInfoText();
    });

    return {
        setCurrentSearch: setCurrentSearch,
        clearSuggestions: clearSuggestions,
        //setOpeningHours: setOpeningHours,
        setGooglePhoneNumber: setGooglePhoneNumber,
        hideDetails: hideDetails,
        mapStateStore: mapStateStore,
        mapClearSearchButtonStore: mapClearSearchButtonStore,
        setBactoStartState: setBactoStartState,
        historyReplaceState: historyReplaceState,
        historyPushState: historyPushState,
    };

})(jQuery);